<template>
	<div class="card">
		<div class="fields__row">
			<div class="fields__item">
				<div class="fields__item">
					<input v-model="data.amount"
						   type="text" id="amount" class="text-field__input" placeholder="Сумма">
					<div class="text-muted">
						Укажите сумму перевода, максимальная сумма 5000 рублей.
					</div>
				</div>
				<div class="fields__item">
					<input v-model="data.user"
						   type="text" id="user" class="text-field__input" placeholder="ID или username пользователя">
					<div class="text-muted">
						Укажите пожалуйста ID получателя или имя пользователя
					</div>
				</div>
				<div class="fields__item">
					<input v-model="data.comment"
						   type="text" id="comment" class="text-field__input" placeholder="Комментарий">
					<div class="text-muted">
						Дополнительная информация к переводу
					</div>
				</div>

				<button
					@click="transfer"
					:disabled="disableButton"
					type="submit" class="btn btn--primary fields__item">
					Перевести
				</button>
			</div>
			<div class="fields__item">
				<div class="table-wrap" v-if="Object.keys(transfers).length">
					<table class="table table--bordered">
						<thead>
							<tr>
								<th><b>Пользователь</b></th>
								<th><b>Сумма</b></th>
								<th><b>Дата</b></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(transfer) in transfers">
								<td>
									<b v-if="!transfer.sender" class="text-success">
										<svg height="14px" width="14px">
											<use href="#svg-icon-arrow-down"></use>
										</svg>
									</b>
									<b v-if="transfer.sender" class="text-danger">
										<svg height="14px" width="14px">
											<use href="#svg-icon-arrow-up"></use>
										</svg>
									</b>

									{{ transfer.sender ? transfer.to.username : transfer.from.username }}
									<small v-if="transfer.comment" class="text-muted">
										{{ transfer.comment }}
									</small>
								</td>
								<td>{{ Number(transfer.amount).toFixed(2) }} ₽</td>
								<td>{{ transfer.datetime }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="text-center card__title" v-else>
					<h4>Вы ещё не произвели ни одного перевода</h4>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	import { useUserStore } from '../../stores/User';
	import {mapState} from "pinia";
	import Bonus from "../bonus/Bonus.vue";

    export default {
		components: {Bonus},

        data() {
            return {
                transfers: [],
                data: {
                    amount: '',
                    user: null,
                    comment: null
                },
                isValid: true,
                error: {
                    show: false,
                    message: ''
                },
                success: {
                    show: false,
                    message: ''
                },
                disableButton: false
            }
        },
        mounted() {
            this.$root.isLoading = true;

            if(!this.$cookie.get('token')) {
                this.$root.isLoading = false;
                this.$router.go(-1);
            }

            this.get();
        },
		computed: {
			...mapState(useUserStore, ['user']),
		},
        methods: {
            validate() {
                this.isValid = true;
                this.disableButton = true;
                this.data.amount = Number(this.data.amount).toFixed(2);

                if(isNaN(this.data.amount) || this.data.amount > 5000 || this.data.amount < 10) {
                    this.isValid = false;
                    this.$toast.error('Введите сумму от 10 до 5000');
                }

                if(this.data.user === '') {
                    this.isValid = false;
                    this.$toast.error('Укажите пожалуйста ID получателя или имя пользователя');
                }

                this.disableButton = false;

                return this.isValid;
            },
            get() {
                this.$root.axios.get('/api/transfers')
                .then(res => {
                    this.transfers = res.data.transfers;
                    this.$root.isLoading = false;
                });
            },
            transfer() {
                if(!this.validate()) return;

                this.$root.axios.post('/api/transfers/send', this.data)
                .then(res => {
                    this.$toast.success(res.data.message);
                    this.user.balance = res.data.balance;

                    this.get();
                }).catch(error => {
                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                });
            },
        }
    }
</script>
